import { State, Effect, Actions, dispatch } from 'jumpstate'
import { showLoading, hideLoading } from 'react-redux-loading-bar'
import axios from 'axios'
import apiAddress from '../utils/APIEndPointAddress'
import {map} from 'lodash'
import qs from 'qs'

const HorseState = State({
  initial: {
    currentHorse: null,
    reportTypes: [],
    reportPhotoTypes: []
  },
  setCurrentHorse (state, payload) {
    return {
      ...state,
      currentHorse: payload
    }
  },
  horseLiked (state, payload) {
    return {
      ...state,
      currentHorse: {
        ...state.currentHorse,
        likes: {
          count: state.currentHorse.likes.count + 1,
          isLike: true
        }
      }
    }
  },
  horseUnliked (state, payload) {
    return {
      ...state,
      currentHorse: {
        ...state.currentHorse,
        likes: {
          count: state.currentHorse.likes.count - 1,
          isLike: false
        }
      }
    }
  },
  setHorseReportTypes (state, payload) {
    return {
      ...state,
      reportTypes: payload
    }
  },
  setHorseReportPhotoTypes (state, payload) {
    return {
      ...state,
      reportPhotoTypes: payload
    }
  }
})

// eslint-disable-next-line
const horseLikeEffect = Effect('horseLike', (horseId) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  let urlParams = qs.stringify({horse_id: horseId})
  return axios.post(`${apiAddress}horse/like`, urlParams).then((res) => Actions.horseLiked())
})

// eslint-disable-next-line
const horseUnlikeEffect = Effect('horseUnlike', (horseId) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  let urlParams = '?' + qs.stringify({horse_id: horseId})
  return axios.delete(`${apiAddress}horse/like${urlParams}`).then((res) => Actions.horseUnliked())
})

// eslint-disable-next-line
const horseInfoEffect = Effect('horseInfo', (key) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  let urlParams = '?' + qs.stringify({key: key})
  return axios.get(`${apiAddress}horse/info${urlParams}`).then((res) => {
    const horse = {...res.data, key: key}
    Actions.setCurrentHorse(horse)
    return res.data
  }).catch(e => {
    return Promise.reject(e)
  })
})

// eslint-disable-next-line
const loadHorseReportTypesEffect = Effect('loadHorseReportTypes', () => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  return axios.get(`${apiAddress}horse/report-type`).then((res) => {
    let data = map(res.data, (item) => {
      return {label: item.text, value: item.value}
    })
    Actions.setHorseReportTypes(data)
  })
})

// eslint-disable-next-line
const horseReportEffect = Effect('horseReport', (report) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  let urlParams = qs.stringify(report)
  return axios.post(`${apiAddress}horse/report`, urlParams)
})

// eslint-disable-next-line
const loadHorseReportPhotoTypesEffect = Effect('loadHorseReportPhotoTypes', () => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  return axios.get(`${apiAddress}horse/report-photo-type`).then((res) => {
    let data = map(res.data, (item) => {
      return {label: item.text, value: item.value}
    })
    Actions.setHorseReportPhotoTypes(data)
  })
})

// eslint-disable-next-line
const horseReportPhotoEffect = Effect('horseReportPhoto', (report) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  let urlParams = qs.stringify(report)
  return axios.post(`${apiAddress}horse/report-photo`, urlParams)
})

// eslint-disable-next-line
const horseReportDeadEffect = Effect('horseReportDead', (deadReport) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  let urlParams = qs.stringify(deadReport)
  return axios.post(`${apiAddress}horse/report-die`, urlParams)
})

// eslint-disable-next-line
const horseAddImageEffect = Effect('horseAddImage', (addImage) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })
  let urlParams = qs.stringify(addImage)
  return axios.post(`${apiAddress}horse/add-photo`, urlParams)
})

//eslint-disable-next-line
const uploadHorsePhotoEffect = Effect('uploadHorsePhoto', (params) => {
  axios.interceptors.request.use((config) => {
    dispatch(showLoading())
    return config
  })
  axios.interceptors.response.use((response) => {
    dispatch(hideLoading())
    return response
  }, (error) => {
    dispatch(hideLoading())
    return Promise.reject(error)
  })

  var source = axios.CancelToken.source()
  const config = {
    onUploadProgress: params.progress,
    cancelToken: source.token
  }
  params.requestSetter(source)
  return axios.post(`${apiAddress}horse/add-photo`, params.data, config).then((res) => {
    let formData = {}
    for (var pair of params.data.entries()) {
      if (pair[0] !== 'file') {
        formData[pair[0]] = pair[1]
      }
    }
    return res
  }).catch((err) => {
    if (axios.isCancel(err)) {
      return Promise.reject(Error('آپلود به درخواست شما لغو شد'))
    }
    if (err.response.status === 422 && err.response.data.errors.file !== undefined) {
      return Promise.reject(err.response.data.errors.file[0])
    }
    return Promise.reject(Error('در آپلود مشکلی پیش آمده است، دوباره تلاش کنید.'))
  })
})

export default HorseState



// WEBPACK FOOTER //
// ./src/states/horse.js